import { ViewDensity, ViewType } from "@common/types/views/views";
import {
    OrganizationActivityColumn,
    OrganizationActivityView,
} from "@common/types/views/organizationActivityView";

export function createDefaultOrganizationActivityView(): OrganizationActivityView {
    return {
        type: ViewType.ORGANIZATION_ACTIVITY,
        columns: [
            { id: OrganizationActivityColumn.CREATED_AT },
            { id: OrganizationActivityColumn.ACTOR },
            { id: OrganizationActivityColumn.ACTION },
            {
                id: OrganizationActivityColumn.CLIENTS,
                options: { pin: "right" },
            },
            {
                id: OrganizationActivityColumn.ACTIONS,
                options: { pin: "right" },
            },
        ],
        filters: {},
        options: {
            selection: true,
            density: ViewDensity.MD,
        },
    };
}
